module.exports = __webpack_public_path__ + "static/media/help-circle-dark.718a4c58.svg";